import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=23fe00f6&scoped=true&"
import script from "./NavbarComponent.vue?vue&type=script&lang=js&"
export * from "./NavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=23fe00f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe00f6",
  null
  
)

export default component.exports